<template>
  <div style="height:100%">
    <QTHDistributionEditPro></QTHDistributionEditPro>
    <!-- <el-tabs v-model="tab_index">
      <el-tab-pane :label="$t('tab.main_plan_edit_proofing')">
        <QTHDistributionEditPro></QTHDistributionEditPro>
      </el-tab-pane>
      <el-tab-pane :label="$t('tab.main_plan_view_proofing')">
        <QTHDistributionSearchPro></QTHDistributionSearchPro>
      </el-tab-pane>
    </el-tabs> -->
  </div>
</template>
<script>
import QTHDistributionEditPro from './QTHDistributionEditPro.vue'
// import QTHDistributionSearchPro from './QTHDistributionSearchPro.vue'

export default {
  components: {
    QTHDistributionEditPro,
    // QTHDistributionSearchPro,
  },
  data() {
    return {
      tab_index: "0"
    }
  },
  mounted() {
    // let href = window.location.href.split("?")
    // if (href.length > 0) {
    //   if (href[1] && href[1] == "tab=2") {
    //     this.tab_index = "1"
    //   }
    // }
  }
}
</script>
